@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@s-ui/react-molecule-accordion/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-layout-page-content/lib/index';
@import '~@adv-mt/mt-modal-basic-content/lib/index';
@import '~@adv-mt/mt-modal-transaction-cancel/lib/index';
@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-image/lib/index';
@import '~@s-ui/react-molecule-checkbox-field/lib/index';
@import '~@s-ui/react-molecule-input-field/lib/index';
@import '~@s-ui/react-molecule-modal/lib/index';
@import '~@s-ui/react-molecule-radio-button-field/lib/index';
@import '~@s-ui/react-molecule-radio-button-group/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@s-ui/react-atom-icon/lib/index';
@import '../../components/transactionTrustFooter.scss';

$c-card-ad-attr-item: $c-gray-dark-1 !default;
$h-modal-basic-content-header-image: 180px;
$lh-card-ad-attr-item: 16px !default;
$mah-mt-user-transaction-price-content-mobile: 318px;
$mah-mt-user-transaction-price-content: 418px;
$miw-mt-user-transaction-price-form-button: 200px;
$w-mt-user-transaction-price-side: 328px;

.mt-TransactionSellerId {
  &-mainContent {
    color: $c-primary;
    display: flex;
    flex-direction: column;
    font-size: $fz-l;
    gap: $g-xl;
  }

  &-helpText {
    align-items: center;
    background-color: $c-neutral;
    border-radius: $bdrs-l;
    display: flex;
    font-size: $fz-l;
    gap: $g-m;
    padding: $p-l;
  }
}
